import { ROUTES } from "./siteConfig";

export const industryPages = {
  aerzte: {
    path: "/webdesign-fuer-aerzte",
    title: "Webdesign für Ärzte",
    metaTitle: "Webdesign für Ärzte | Websites für Arztpraxen & Mediziner",
    metaDescription:
      "Webdesign für Ärzte und Arztpraxen in Österreich: Professionelle Praxis-Websites, DSGVO-konform, mit klarer Information und Termin-Optionen.",
    h1: "Webdesign für Ärzte – Professionelle Websites für Arztpraxen",
    intro:
      "Eine klare, vertrauenswürdige Website ist für Arztpraxen und Mediziner unverzichtbar. Wir entwickeln Websites, die Patienten informieren, Ihre Leistungen darstellen und Ihre Praxis professionell präsentieren – inklusive Hinweisen zu Datenschutz und Erreichbarkeit.",
    sections: [
      {
        title: "Was zeichnet eine gute Arzt-Website aus?",
        content:
          "Übersichtliche Darstellung von Leistungen, Team und Sprechzeiten; klare Kontaktmöglichkeiten; Hinweise zu Datenschutz und Impressum. Optional: Anbindung von Online-Terminbuchung oder Anamnese-Formularen. Wir achten auf DSGVO-konforme Umsetzung und barrierefreie Struktur.",
      },
      {
        title: "Für wen eignet sich unser Webdesign für Ärzte?",
        content:
          "Für Fachärzte, Allgemeinmediziner, Zahnärzte, Therapeuten und Kliniken in Österreich, die ihre Online-Präsenz verbessern oder neu aufsetzen möchten.",
      },
    ],
    faqs: [
      {
        q: "Muss die Website für Ärzte DSGVO-konform sein?",
        a: "Ja. Gerade bei Gesundheitsdaten und Kontaktformularen ist die Einhaltung der DSGVO wichtig. Wir setzen auf datenschutzfreundliche Lösungen und verweisen in der Datenschutzerklärung auf die Verarbeitung.",
      },
    ],
    relatedLinks: [
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Webdesign Kosten Österreich", path: ROUTES.costWebdesign },
      { label: "Webdesign Agentur Kärnten", path: ROUTES.locationKaernten },
    ],
  },
  restaurants: {
    path: "/webdesign-fuer-restaurants",
    title: "Webdesign für Restaurants",
    metaTitle: "Webdesign für Restaurants | Websites für Gastronomie",
    metaDescription:
      "Webdesign für Restaurants und Gastronomie in Österreich: Menü, Öffnungszeiten, Reservierung, Events. Professionelle Websites für Ihr Lokal.",
    h1: "Webdesign für Restaurants – Websites für die Gastronomie",
    intro:
      "Ihr Restaurant verdient eine Website, die Appetit macht und Gäste informiert: Speisekarte, Öffnungszeiten, Reservierung oder Kontakt. Wir gestalten Websites, die zu Ihrer Gastronomie passen und auf allen Geräten gut aussehen.",
    sections: [
      {
        title: "Typische Inhalte einer Restaurant-Website",
        content:
          "Speisekarte, Getränkekarte, Öffnungszeiten, Team oder Geschichte, Galerie, Kontakt und optional Reservierung oder Anbindung an Buchungssysteme. Wir integrieren auch Social-Media-Feeds (z. B. Instagram) für aktuelle Fotos und Events.",
      },
    ],
    faqs: [
      {
        q: "Kann ich die Speisekarte selbst aktualisieren?",
        a: "Ja. Wir bauen die Website so, dass Sie Texte und Bilder selbst pflegen können – oder wir übernehmen die Pflege gegen Aufpreis.",
      },
    ],
    relatedLinks: [
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Webdesign für Unternehmen", path: ROUTES.industryUnternehmen },
    ],
  },
  handwerker: {
    path: "/webdesign-fuer-handwerker",
    title: "Webdesign für Handwerker",
    metaTitle: "Webdesign für Handwerker | Websites für Handwerksbetriebe",
    metaDescription:
      "Webdesign für Handwerker in Österreich: Professionelle Websites für Maler, Elektriker, Installateure und alle Gewerbe. Referenzen, Leistungen, Kontakt.",
    h1: "Webdesign für Handwerker – Websites für Ihr Handwerksunternehmen",
    intro:
      "Handwerksbetriebe werden online gesucht – ob Maler, Elektriker, Installateur oder Tischler. Eine professionelle Website zeigt Ihre Leistungen, Referenzen und Kontaktmöglichkeiten und hilft Ihnen, Aufträge zu gewinnen.",
    sections: [
      {
        title: "Was braucht eine Handwerker-Website?",
        content:
          "Leistungen, Referenzen oder Galerie, Bewertungen oder Zertifikate, Kontakt und optional Anfrage-Formular. Wir setzen auf klare Struktur und Suchmaschinen-Optimierung, damit Sie bei lokalen Suchen gefunden werden.",
      },
    ],
    faqs: [
      {
        q: "Werden wir bei Google in der Region gefunden?",
        a: "Wir optimieren die Website für Suchanfragen in Ihrer Region (z. B. „Maler Klagenfurt“) und achten auf lokale SEO (Standort, Kontaktdaten, strukturierte Daten).",
      },
    ],
    relatedLinks: [
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Webdesign Agentur Wolfsberg", path: ROUTES.locationWolfsberg },
    ],
  },
  unternehmen: {
    path: "/webdesign-fuer-unternehmen",
    title: "Webdesign für Unternehmen",
    metaTitle: "Webdesign für Unternehmen | Professionelle Unternehmenswebsites",
    metaDescription:
      "Webdesign für Unternehmen und KMU in Österreich: Professionelle Unternehmenswebsites, die Vertrauen schaffen und Kunden ansprechen.",
    h1: "Webdesign für Unternehmen – Professionelle Websites für KMU",
    intro:
      "Unternehmen und KMU brauchen eine Website, die ihre Kompetenz und ihre Leistungen klar darstellt. Wir entwickeln Unternehmenswebsites mit klarer Struktur, ansprechendem Design und Suchmaschinen-Optimierung.",
    sections: [
      {
        title: "Von der Unternehmenswebsite bis zum Relaunch",
        content:
          "Ob Neuerstellung oder Relaunch: Wir analysieren Ihre Ziele und Zielgruppen und setzen eine Website um, die zu Ihrem Unternehmen passt. Inklusive Corporate Design-Anbindung, Kontaktformular und optional Blog oder News.",
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Unternehmenswebsite?",
        a: "Die Kosten hängen von Umfang und Funktionalität ab. Eine Übersicht finden Sie auf unserer Seite Webdesign Kosten Österreich.",
      },
    ],
    relatedLinks: [
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Corporate Design", path: ROUTES.serviceCorporateDesign },
      { label: "Webdesign Kosten Österreich", path: ROUTES.costWebdesign },
    ],
  },
};
